// Go-Live (Juni 2026) – Wiederverwendbarer Footer mit den rechtlichen Pflichtseiten.
// Login-frei erreichbar. Reine Verlinkung; Inhalte: siehe legalContent.js.
// ABO-RECHT-02, Betreiberfreigabe 27.10.2026 — a href (gleicher Tab), „Auftragsverarbeitung“ wie landing/index.html.
const LINKS = [
  { to: "/impressum", label: "Impressum", testId: "legal-link-impressum" },
  { to: "/datenschutz", label: "Datenschutz", testId: "legal-link-datenschutz" },
  { to: "/agb", label: "AGB", testId: "legal-link-agb" },
  { to: "/avv", label: "Auftragsverarbeitung", testId: "legal-link-avv" },
];

export const LegalFooter = ({ className = "" }) => (
  <footer
    data-testid="legal-footer"
    className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-slate-400 ${className}`}
  >
    {LINKS.map((l, i) => (
      <span key={l.to} className="flex items-center gap-x-4">
        {i > 0 && <span className="text-slate-300">·</span>}
        <a
          href={l.to}
          data-testid={l.testId}
          className="hover:text-slate-700 transition-colors"
        >
          {l.label}
        </a>
      </span>
    ))}
  </footer>
);
